import styled from "styled-components";
import { fontFamilyDefault, Heading1 } from "styles/typography";

export const HeaderDiv = styled.div`
  width: 30vw;
  display: flex;
  flex-direction: column;
`;

export const RightHeaderDiv = styled(HeaderDiv)`
  &&& {
    width: 100%;
  }
`;

export const StyledH1 = styled(Heading1)`
  &&& {
    display: flex;
    margin-bottom: 0;
    justify-content: space-between;
    height: 3rem;
  }
`;

export const RightStyledH1 = styled(Heading1)`
  &&& {
    display: flex;
    justify-content: space-between;
    height: 3rem;
  }
`;

export const ComponentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SingleWrapperDiv = styled.div`
  display: flex;
  width: 30vw;
  flex-direction: column;
  height: 4rem;
`;

export const SideBySideWrapperDiv = styled.div`
  display: inline-flex;
  width: 30vw;
  justify-content: space-between;
  height: 3.5rem;
`;

export const ConsentsDiv = styled(SideBySideWrapperDiv)`
  &&& {
    height: 6rem;
  }
`;

export const SubHeaderDiv = styled.div`
  color: #595959;
  font-size: 12px;
  padding-top: 2em;
`;

export const SingleSubTitleDiv = styled.div`
  width: 30vw;
  color: #000000;
  font-size: 16px;
  padding-top: 0.25em;
`;

export const SideBySideSubTitleDiv = styled.div`
  width: 15vw;
  color: #000000;
  font-size: 16px;
  padding-top: 0.25em;
`;

export const StatusDiv = styled.div`
  width: max-content;
  border: 1px solid #000000;
  border-radius: 1.25rem;
  padding: 0.25em;
`;

export const CollapseExpandButton = styled.button`
  border: none;
  background: none;
  text-decoration: underline;
  font-size: 12px;
  padding: 0.5rem;
  cursor: pointer;
  text-transform: uppercase;
`;

export const AudioPlayer = styled.audio`
  width: 40vw;
`;
export const ModalAudioPlayer = styled.audio`
  width: 100%;
  margin: 20px auto;
`;

export const ExpandableTextWrapper = styled.div`
  font-family: ${fontFamilyDefault};
  background-color: #fefaf1;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  padding: 1rem;
`;

export const InlineTextWrapper = styled.div`
  background-color: white;
`;

// this is so that the newline join works for displaying activities properly
export const PlaylistTableWrapper = styled.div`
  white-space: pre;
`;
export const InfoTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #595959;
`;
export const RowTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  opacity: 0.8;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
export const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 30px;
  align-items: flex-start;
`;
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto;
  gap: 30px;
`;
export const InfoDiv = styled.div`
  display: grid;
  gap: 10px;
`;

export const TableSection = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
`;
export const MetricsDetails = styled.tr`
  gap: 25px;
  background: #fefaf1;
  border: 1px solid rgba(0, 0, 0, 0.14);
`;

export const MetricTableSection = styled.table`
  border-spacing: 0px;
  border: 1px solid rgba(0, 0, 0, 0.14);
`;

export const MetricsHead = styled.tr`
  gap: 25px;
  border: 1px solid #00000024;
  background: #5f839a;
  border: 1px solid rgba(0, 0, 0, 0.14);
`;
export const TableHeadTitle = styled.td`
  font-size: 12px;
  font-weight: bold;
  min-width: 40px;
  text-align: center;
  color: #ffffff;
  padding: 8px 15px;

  :first-child {
    min-width: 100px;
    text-align: left;
  }
  :nth-child(3) {
    min-width: 100px;
  }
`;
export const MetricsData = styled.td`
  font-size: 12px;
  font-weight: bold;
  min-width: 40px;
  text-align: center;
  padding: 8px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);

  :first-child {
    min-width: 100px;
    text-align: left;
  }
  :nth-child(3) {
    min-width: 100px;
  }
`;

export const CurrentWeekOverview = styled.div`
  width: max-content;
  display: flex;
`;
export const WeekOverview = styled.table`
  width: max-content;
  border-spacing: 0px;
`;
export const VoicemessageTitle = styled.td`
  max-width: 175px;
  font-size: 14.7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const VoicemessageTitleLink = styled.td`
  max-width: 175px;
  font-size: 14.7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #1976d2;
  text-decoration: underline;
`;
export const NewActivity = styled.div`
  background: #000;
  color: #fff;
  padding: 5px;
  width: 50px;
  /* margin: 0 auto; */
  border-radius: 16px;
  text-align: center;
  margin-left: 10px;
`;

export const WeekDetails = styled.td`
  border: 1px solid #00000024;
  background: #fefaf1;
  width: 100%;
  min-width: 280px;
  padding: 10px;
  max-width: 300px;
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  padding-top: 10px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: capitalize;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 400;
`;
export const TableLabel = styled.div`
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 7px;
`;
export const TopSection = styled.div`
  display: flex;
  width: 100%;
  gap: 50px;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 30px;
`;
export const Loader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 10px;
`;
export const HeadSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Close = styled.div`
  width: max-content;
  margin-left: auto;
  cursor: pointer;
  margin-right: 10px;
`;
export const InactiveModal = styled.div`
  background: white;
  padding: 30px 15px;
  border-radius: 10px;
  min-width: 300px;
`;
export const ModalContainer = styled.div`
  height: 100vh;
  display: flex;

  align-items: center;
  justify-content: center;
`;
export const NoteContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;
export const Notes = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-decoration: underline;
`;

export const CallHeadSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;
export const CheckTable = styled.div`
  .rdt_TableHeadRow {
    background: #5f839a;
  }
  .rdt_TableHead {
    color: #ffffff;
    font-weight: bold !important;
  }
`;
export const Discarded = styled.div`
  font-size: 16px;
  color: #f40012;
`;
export const Note = styled.div`
  font-size: 16px;
  color: #f40012;
  margin: 30px 0;
`;

export const Reflection = styled.div`
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const BdlNote = styled.div`
  font-size: 16px;
  color: #f40012;
`;
export const RecordLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  margin: 10px 0 5px 0;
`;

export const UserDetailsBox = styled.div`
  width: 100%;

  button {
    width: max-content;
    background: #000000;
    border-radius: 2px;
    height: 45px;
    font: 14px/22px "Museo Sans", sans-serif;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #ffffff;
    :hover {
      background: #000000;
    }
  }
`;
